<template>
    <section class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     :btn_edit="false"
                     :btn_add="false"
                     :btn_delete="false"
                     btn_download
                     btn_review
                     @review="handleMeetingReview"
                     @download="handleMeetingDownload"
                     :btn_records="!invisible"
                     @records="handleRecords"
        >
            <div class="pull-right">
                <calendar-picker-filter :value="search.date_range"
                                        :shortcuts="shortcuts"
                                        @change="handleCalendarChange"></calendar-picker-filter>
            </div>
        </front-table>
        <!--编辑界面-->

        <meeting-view :view_mode="view_mode" :single="meeting" @cancel="view_mode = false" rebuild
                      @reload="handleReload">
        </meeting-view>

        <el-dialog title="查看录像"
                   destroy-on-close
                   :visible.sync="view_records"
                   width="75%">
            <div>
                <el-alert type="success" :closable="false" class="mb-3">
                    <div slot="title">
                        <div style="font-size:14px;" v-if="meeting.records && meeting.records.length"> 该会议 <b> {{
                                meeting.records.length
                            }} </b>个录像。
                        </div>
                        <div style="font-size:14px;" v-else> 该会议没有录像。</div>
                        <div>
                            <span class="text-warning"> 如果录像信息不正确或者过期，请点击 </span>
                            <el-button type="text" size="mini" @click="handleRebuildRecord"><i
                                class="el-icon-refresh-right"></i> 重新查询会议录像
                            </el-button> | 您也可以点击
                            <el-button type="text" size="mini" @click="handleResentRecordNotice"><i
                                class="el-icon-message"></i> 重发录像通知消息
                            </el-button>
                        </div>
                    </div>
                </el-alert>
                <el-table
                    size="mini"
                    :data="meeting.records"
                    border stripe
                    :default-sort="{prop: 'meeting_time', order: 'descending'}"
                    empty-text="没有找到录像。如有录制，请等待2小时以后再来查看。"
                    style="width: 100%"
                    default-expand-all
                >
                    <el-table-column type="expand">
                        <template #default="props">
                            <el-row :gutter="20">
                                <el-col style="width: 380px" class="mb-2">
                                    <video width="360" height="180" :src="props.row.download_url"
                                           controls="controls"
                                           v-if="props.row.download_url">
                                        your browser does not support the video tag
                                    </video>
                                </el-col>
                                <el-col style="width: calc(100% - 390px); margin-left: 9px; float: left; min-width: 400px; ">
                                    <el-tabs v-model="record_tab" type="border-card">
                                        <el-tab-pane label="视频文件下载" name="1" class="p-2" style="font-size: 14px;height: 108px;">
                                            <ul class="meeting-summary p-0">
                                                <li style="line-height: 30px;">
                                                    <a :href="props.row.download_url" target="_blank"
                                                       v-if="props.row.download_url">
                                                        <i class="el-icon-video-camera"></i> 视频文件</a>
                                                </li>
                                                <li style="line-height: 30px;" v-for="x in props.row.meeting_summary"
                                                    :key="x.download_address">
                                                    <a :href="x.download_address" target="_blank"><i
                                                        class="el-icon-paperclip"></i>
                                                        会议纪要.{{ x.file_type }}</a>
                                                </li>
                                            </ul>
                                        </el-tab-pane>
                                        <el-tab-pane label="分享录像设置" name="2" v-if="meeting.platform_code == 1"
                                                     class="p-2" style="height: 108px;">
                                            <el-form :inline="true">
                                                <el-form-item label="分享对象" class="mb-0">
                                                    <el-select size="mini" v-model="props.row.share_mode"
                                                               placeholder="请选择分享对象">
                                                        <el-option label="请选择" value='0'></el-option>
                                                        <el-option label="所有人" value='1'></el-option>
                                                        <el-option label="校内SSO" value='2'></el-option>
                                                        <el-option label="与会者" value='3'></el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="观看密码" class="mb-0">
                                                    <el-input size="mini" v-model="props.row.password" clearable
                                                              placeholder="八位密码"></el-input>
                                                </el-form-item>
                                                <br />
                                                <el-form-item label="" class="mb-0">
                                                    <el-switch v-model="props.row.disable_password"
                                                               :active-value="'1'"
                                                               :inactive-value="'0'"
                                                               active-text="不使用密码"
                                                    ></el-switch>
                                                </el-form-item>
                                                <el-form-item label="" class="mb-0">
                                                    <el-switch v-model="props.row.allow_download"
                                                               :active-value="'1'"
                                                               :inactive-value="'0'"
                                                               active-text="允许下载"
                                                    ></el-switch>
                                                </el-form-item>
                                                <el-form-item class="mb-0">
                                                    <el-button size="mini" type="primary"
                                                               @click="handleUpdateShareMode(props.row)"
                                                               icon="el-icon-edit">
                                                        修改
                                                    </el-button>
                                                </el-form-item>
                                            </el-form>
                                        </el-tab-pane>
                                    </el-tabs>
                                </el-col>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="录制时间">
                        <template #default="scope">
                            {{ scope.row.meeting_time }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="分享链接"
                        prop="play_url">
                        <template #default="scope">
                            <div class="d-inline">
                                <el-button size="mini" type="text"
                                           icon="el-icon-document-copy"
                                           @click="copyClipboard(scope.row.play_url+' 分享密码:'+scope.row.password)">复制分享链接
                                </el-button>
                                <el-button size="mini" type="text" @click="jumpUrl(scope.row.play_url)"
                                           icon="el-icon-link">点击观看
                                </el-button>
                                <span class="text-danger ml-3 d-inline-block">密码:{{ scope.row.password }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="下载" >
                        <template #default="props">
                            <a :href="props.row.download_url" target="_blank" v-if="props.row.download_url"><i
                                class="fa fa-download"></i> 下载录像</a>
                            <span v-if="props.row.meeting_summary">
                            <a class="d-inline-block ml-2" :href="x.download_address" target="_blank"
                               v-for="x in props.row.meeting_summary.filter(i=>i.file_type==='docx')"
                               :key="x.download_address">
                                <i class="el-icon-paperclip"></i> 纪要.{{ x.file_type }}</a>
                            </span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="view_records=false">确 定</el-button>
            </span>
        </el-dialog>
        <meeting-detail-report-table ref="meeting_detail_report" :meeting="meeting" :emails="emails" v-if="meeting"></meeting-detail-report-table>
        <div class="clearfix"></div>
    </section>
</template>

<script>
import FrontTable from "../components/front-table";
import FrontMixins from "../common/mixins/front-mixins";
import MeetingView from "../components/meeting-view";
import CalendarPickerFilter from "@/components/calendar-picker-filter";
import MeetingDetailReportTable from "../components/meeting-detail-report-table.vue";

export default {
    mixins: [FrontMixins],
    name: 'meeting-detail',
    components: {MeetingDetailReportTable, FrontTable, MeetingView, CalendarPickerFilter},
    created() {
        this.model = 'Report.Meeting.Detail';
        this.search.date_range = [
            ((new Date((new Date().getTime() - 3600 * 1000 * 24 * 30)).Format('yyyy-MM-dd 23:59')))
            , ((new Date()).Format('yyyy-MM-dd 23:59'))
        ];
        this.search.use_date_range = true;
    },
    data() {
        return {
            record_tab:'1',
            show_edit: false,
            meeting: {},
            download_report: false,
            meeting_records: [],
            view_records: false,
            shortcuts: [
                {
                    text: '当日全天',
                    onClick(picker) {
                        const date = new Date();
                        picker.$emit('pick', [date.Format('yyyy-MM-dd 00:00'), date.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一周',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一月',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                },
                {
                    text: '过去一年',
                    onClick(picker) {
                        const start = new Date();
                        const end = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                        picker.$emit('pick', [start.Format('yyyy-MM-dd 00:00'), end.Format('yyyy-MM-dd 23:59')]);
                    }
                }]

        }
    },
    computed: {
        emails() {
            let data = [];
            if (this.meeting.attendees) {
                try {
                    data = JSON.parse(this.meeting.attendees);
                } catch (e) {
                    console.log(e)
                }
            }
            return data;
        },
        invisible() {
            return this.$organization.org === 'sjtu';
        }
    },
    methods: {
        handleRebuildRecord() {
            this.$api('Query.Rebuild.Record', {id: this.meeting.id}, true).then(() => {
                this.$notice.success('录像重新下载完成！');
                this.$emit('cancel');
            });
        },
        handleResentRecordNotice() {
            this.$api('Query.Resend.RecordNotice', {id: this.meeting.id}, true).then(() => {
                this.$notice.success('录像通知邮件已经发送！');
            });
        },
        jumpUrl(url) {
            window.open(url, "_blank");
        },
        copyClipboard(str) {
            this.$copyText(str).then(() => {
                this.$notice.success('已经复制到剪贴板');
            }).catch(() => {
                this.$notice.error('复制失败,请手动复制');
            });
        },
        handleUpdateShareMode(row) {
            const data = {
                id: row.id,
                share_mode: row.share_mode,
                password: row.password,
                allow_download: row.allow_download,
                disable_password: row.disable_password,
            };
            if (data.share_mode < '0' || data.share_mode > '3') {
                this.$notice.error('分享对象选择错误');
                return;
            }
            //正则运算判断密码是8位数字和字母,并且有一个大写字母一个小写字母以及数字
            if (row.disable_password != 1) {
                if (!(/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/.test(data.password))) {
                    this.$notice.error('如果自己设置，密码必须是8位数字和字母的组合,必须要有1个大写字母一个小写字母和数字');
                    return;
                }
            }

            this.$api('Report.Meeting.Detail.UpdateShareMode', data, 1).then(() => {
                this.$emit('cancel');
                this.$notice.success('更新成功');
            });
        },
        handleEdit() {
        },
        handleEditSubmit() {
        },
        handleRecords(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id}).then(res => {
                vm.meeting = res.data.data;
                vm.view_records = true;
            });
        },
        handleMeetingReview(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true}, true).then(res => {
                vm.meeting = res.data.data;
                this.view_mode = true;
            });
        },
        handleMeetingDownload(id) {
            let vm = this;
            this.$api('Report.Meeting.Detail' + '.Get', {id: id, review: true, polls:true}, true).then(res => {
                vm.meeting = res.data.data;
                this.download_report = true;
                this.$nextTick(function () {
                    vm.$refs['meeting_detail_report'].exportExcel();
                    this.download_report = false;
                })
            });
        },
    }
}
</script>

<style lang="scss">
ul.meeting-summary {
    margin: 0 0 0 -5px;
    padding: 0;

    li {
        margin: 0;
        list-style: none;
        display: inline-block;

        a {
            display: inline;
            min-width: 100px;
            margin: 0 15px;
            border: 1px solid #999;
            padding: 5px 20px 5px 10px;
            border-radius: 5px;
            text-decoration: none;
            background-color: #F5F5F5;
            color: #0D4E9F;
            transition: all ease-in 100ms;

            &:hover {
                color: orangered;
                border-color: orangered;

            }
        }
    }
}

</style>
